"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayloadTooLargeError = void 0;
const BaseError_1 = require("./BaseError");
class PayloadTooLargeError extends BaseError_1.BaseError {
    constructor(description = "Response payload is too large") {
        super("PayloadTooLargeError", 422, description, true);
    }
}
exports.PayloadTooLargeError = PayloadTooLargeError;
